import { memo } from 'react'

import { copy } from '~/modules/lunya'
import { Field, TextInput } from '~/shared/ui'

import type { NameInputProps } from './types'

/**
 * Поле имени онбординга (A1 / B0).
 *
 * Подпись одна: плавающий лейбл внутри поля. Отдельный оверлайн сверху убран — вместе с
 * плавающим лейблом получалось две подписи об одном и том же.
 */
export const NameInput = memo(function NameInput(props: NameInputProps) {
  const { value, onChange, onFocus, onBlur, hasError = false, autoFocus = false } = props

  return (
    <div onFocus={onFocus} onBlur={onBlur}>
      <Field hint={copy.onb.a1.name_hint} errorText={copy.onb.a1.name_error} hasError={hasError}>
        <TextInput
          value={value}
          onChange={onChange}
          placeholder={copy.onb.a1.name_label}
          size='L'
          hasError={hasError}
          autoFocus={autoFocus}
          ariaLabel={copy.onb.a1.name_label}
        />
      </Field>
    </div>
  )
})
